import { GameHistory } from 'actions/actionTypes';

export const changeSearchFilter = (type, name, value) => ({
  type: GameHistory.CHANGE_SEARCH_FILTER,
  payload: { type, name, value },
});
export const changeCheckBoxAllChecked = (name, checked, list) => ({
  type: GameHistory.CHANGE_CLIENT_ALL_CHECKED,
  payload: { name, checked, list },
});

export const loadGameHistoryListRequest = () => ({
  type: GameHistory.LOAD_GAME_HISTORY_LIST_REQUEST,
});
export const loadGameHistoryListSuccess = (resonseData) => ({
  type: GameHistory.LOAD_GAME_HISTORY_LIST_SUCCESS,
  payload: resonseData,
});
export const loadGameHistoryListFailure = (errorMessage) => ({
  type: GameHistory.LOAD_GAME_HISTORY_LIST_FAILURE,
  payload: errorMessage,
});

export const loadGameHistoryExcelRequest = (afterClickDownload) => ({
  type: GameHistory.LOAD_GAME_HISTORY_EXCEL_REQUEST,
  afterClickDownload,
});
export const loadGameHistoryExcelSuccess = (resonseData) => ({
  type: GameHistory.LOAD_GAME_HISTORY_EXCEL_SUCCESS,
  payload: resonseData,
});
export const loadGameHistoryExcelFailure = (errorMessage) => ({
  type: GameHistory.LOAD_GAME_HISTORY_EXCEL_FAILURE,
  payload: errorMessage,
});
